export default "__VITE_ASSET__DzV7Lrjl__"